import switchCountry from '../components/switch-country';
import MobileMenus from './menus';
import { changeOs } from '../components/detect-os';
import toggleList from '../acf-blocks/toggle-list';
import { changeSrTab } from '../acf-blocks/block-system-requirement-tabs';
import { closeDetailsBox, displayDetailsBox } from '../acf-blocks/block-detailed-feature-list';
import { acceptCookies, rejectCookies } from '../components/cookie';
import { changeCountry } from '../components/detect-country';
const menus = new MobileMenus();
export default () => {
    document.body.addEventListener('click', (event) => {
        var _a, _b;
        const ROLE = (_a = event.target) === null || _a === void 0 ? void 0 : _a.dataset.role;
        const TARGET = event.target;
        if (!ROLE)
            return;
        if (ROLE === 'open-mobile-sub-menu') {
            {
                menus.openMobileSubMenu(TARGET);
            }
        }
        else if (ROLE === 'open-mobile-menu') {
            {
                menus.openMobileMenu(TARGET);
            }
        }
        else if (ROLE === 'open-footer-sub-menu') {
            {
                menus.footerMenu(TARGET);
            }
        }
        else if (ROLE === 'switch-country') {
            {
                switchCountry(TARGET);
            }
        }
        else if (ROLE === 'switch-system') {
            {
                changeOs(TARGET.dataset.os);
            }
        }
        else if (ROLE === 'toggle') {
            {
                toggleList(TARGET);
            }
        }
        else if (ROLE === 'sr-tab') {
            {
                changeSrTab(TARGET);
                return false;
            }
        }
        else if (ROLE === 'open-feature-detail') {
            {
                displayDetailsBox(TARGET);
                event.preventDefault();
            }
        }
        else if (ROLE === 'next-prev-feature-detail') {
            {
                const featureDetail = TARGET.dataset.detailedClass;
                const loaderfeatureDetail = document.querySelector('.js-feature-item-loader');
                const btnfeatureDetail = document.querySelector(`.${featureDetail}`);
                loaderfeatureDetail && loaderfeatureDetail.classList.add('active');
                setTimeout(() => {
                    btnfeatureDetail && btnfeatureDetail.click();
                    loaderfeatureDetail && loaderfeatureDetail.classList.remove('active');
                }, 200);
            }
        }
        else if (ROLE === 'close-feature-detail') {
            {
                event.preventDefault();
                closeDetailsBox();
            }
        }
        else if (ROLE === 'hide-notification') {
            {
                const notification = document.querySelector('.js-page-notification');
                notification && notification.classList.remove('show');
            }
        }
        else if (ROLE === 'menu-point') {
            {
                const activeElement = TARGET.closest('.section-politics-menu-points').querySelector('.active');
                activeElement.classList.remove('active');
                TARGET.classList.add('active');
            }
        }
        else if (ROLE === 'change-country') {
            {
                changeCountry((_b = TARGET.dataset) === null || _b === void 0 ? void 0 : _b.country);
            }
        }
        else if (ROLE === 'reject-cookie') {
            {
                rejectCookies();
            }
        }
        else if (ROLE === 'accept-cookie') {
            {
                acceptCookies();
            }
        }
        else {
            {
            }
        }
    });
};
